import ScrollableContainer from '@databases/layout/ScrollableContainer';
import styled from 'styled-components';

const DatabaseContentWrapper = styled(ScrollableContainer)`
  min-height: 0;
  overflow: visible;
`;

export default DatabaseContentWrapper;
